export enum PreRegistrationPaths {
  ADDITIONAL = '/additional',
  CHECK_LIST = '/checklist',
  PATIENT = '/personal',
  PHOTO_ID = '/photo-id',
  INSURANCE = '/insurance',
  GUARANTOR = '/guarantor',
  CONSENT_FORM = '/consent-form',
  MSPQ = '/mspq',
  PAYMENT = '/payment',
  COMPLETE = '/complete',
  FAILED = '/failed',
  LOGGED_OUT = '/logged-out'
}

export enum StepTypes {
  ADDITIONAL_INFO = 'AdditionalInfo',
  PATIENT_INFO = 'PatientInfo',
  PHOTO_ID = 'PhotoID',
  INSURANCE = 'Insurance',
  GUARANTOR_INFO = 'GuarantorInfo',
  CONSENT_FORM = 'ConsentForm',
  MSPQ = 'Mspq'
}

export const StepTypeToPathMap: Map<string, string> = new Map<string, string>([
  [StepTypes.ADDITIONAL_INFO, PreRegistrationPaths.ADDITIONAL],
  [StepTypes.PATIENT_INFO, PreRegistrationPaths.PATIENT],
  [StepTypes.PHOTO_ID, PreRegistrationPaths.PHOTO_ID],
  [StepTypes.INSURANCE, PreRegistrationPaths.INSURANCE],
  [StepTypes.CONSENT_FORM, PreRegistrationPaths.CONSENT_FORM],
  [StepTypes.MSPQ, PreRegistrationPaths.MSPQ],
  [StepTypes.GUARANTOR_INFO, PreRegistrationPaths.GUARANTOR]
]);

export enum SkipPaymentFlags {
  MSPQ_EXCEPTION = 'mspqException',
  GUARANTOR_INFO_CHANGED = 'guarantorInfoChanged',
  INSURANCE_INFO_CHANGED = 'insuranceInfoChanged',
  SELF_PAY = 'selfPay',
  SELF_PAY_ELECT = 'selfPayElect'
}
